<div class="sample-media-info-container">
  <div class="sample-media-details">
    @for (field of mediaFields; track trackByIndex($index)) {
      <div class="form-row w-50">
        <label [for]="field.key">{{ field.label | translate }}</label>
                <input [id]="field.key" type="text" readonly [value]="field.enum
                      ? getEnumDisplayValue(field.enum, $safeNavigationMigration(sampleMediaDetails?.[field.key]))
                      : (sampleMediaDetails?.[field.key] ?? '-')" />
        </div>
      }
    </div>

    <div class="action-buttons">
      <button class="btn" (click)="openSampleMediaDialog()">{{'Add' | translate}}</button>
    </div>
  </div>

  <div class="custom-theme-table">
    <div class="custom-scrollbar table-responsive outer-bordered-table">
      <table mat-table  class="table table-striped" [dataSource]="dataSource">
        <tr class="mat-row" *matNoDataRow [ngClass]="{'loading-row': isLoading}">
          <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">
            @if (isLoading) {
              <app-rings-loader class="bg-transparent"></app-rings-loader>
            } @else {
              {{'No data matching the filter' | translate}}
            }
          </td>
        </tr>

        <ng-container matColumnDef="name">
          <th mat-header-cell class="left-aligned" *matHeaderCellDef>{{'Analytical Method Name' | translate}}</th>
          <td mat-cell class="left-aligned" *matCellDef="let element">{{ element.name || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{'Actions' | translate}}</th>
          <td mat-cell *matCellDef="let element" class="text-align-right">
            <span class="material-icons edit cursor-pointer material-grey-icon"
            (click)="openAnalyticalDialog(element.id)">edit</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;" [class.even-row]="even"></tr>
      </table>
    </div>
    <div class="paginator-container">
      <span>{{'Displaying' | translate}}</span>
      <mat-paginator [length]="dataSource.data.length" [pageSizeOptions]="[5, 10, 20]"
      [pageSize]="10"></mat-paginator>
    </div>
  </div>